import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NotFoundPage from "./pages/not-found/NotFoundPage";
import Navbar from "./components/shared/Navbar";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import CreateAndEditPostPage from "./pages/create-post/CreatePostPage";
import UserFeedback from "./pages/user-feedback/UserFeedback";
import SignUpPage from "./pages/auth/SignUpPage";
import SignInPage from "./pages/auth/SignInPage";
import ForgotPasswordPage from "./pages/auth/ForgotPassword";
import ResetPasswordPage from "./pages/auth/ResetPassword";
import PostsPage from "./pages/posts/posts";
import SavedPosts from "./pages/saved-posts/SavedPosts";
import PostDetailsPage from "./pages/postDetailsPage/postDetailsPage";
import ProfilePage from "./pages/profile/profilePage";
import AboutUsPage from "./pages/about-us/AboutUsPage";
import DemoAccessPage from "./pages/DemoAccessPage/DemoAccessPage";
import RoommateEntryPage from "./pages/roommate-entry/RoommateEntryPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root redirect */}
        <Route path="/" element={<Navigate to="/fmr" />} />

        <Route path="fmr">
          {/* Public routes */}
          <Route index element={<RoommateEntryPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="demo-access" element={<DemoAccessPage />} />

          {/* Protected routes with Navbar */}
          <Route
            element={
              <ProtectedRoute>
                <Navbar />
              </ProtectedRoute>
            }
          >
            <Route path="posts" element={<PostsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="post-details/:postId" element={<PostDetailsPage />} />
            <Route path="saved-posts" element={<SavedPosts />} />
            <Route path="create-post" element={<CreateAndEditPostPage />} />
            <Route path="user-feedback" element={<UserFeedback />} />
            <Route path="about-us" element={<AboutUsPage />}></Route>
          </Route>

          {/* 404 page */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
